<template>
	<div class="error-mess">
		<div class="logo">

		</div>
		<div class="error-mess__title">
			<slot></slot>
		</div>
		<div class="error-mess__buttons">
			<button class="button"
        @click="okAction">{{ $t('global.ok') }}</button>
		</div>
	</div>
</template>

<script>
export default {
    props: ['okAction'],
    data() {
        return {}
    },
}
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/main';
.error-mess {
	max-width: 100%;
	width: 640px;
	height: 430px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	& .logo {
		width: 80px;
		height: 80px;
		background-image: url('/images/icon/error-logo.svg');
		background-size: cover;
		background-position: center;
		margin-bottom: 20px;
	}
	&__title {
		font-family: $fontMedium;
		font-size: 16px;
		color: #d85a4a;
		text-align: center;
		max-width: 515px;
		margin-bottom: 50px;
		line-height: 1.2;
	}
	&__buttons {
		display: flex;
		justify-content: center;
		width: 100%;
		max-width: 396px;
		margin-left: auto;
		margin-right: auto;
		& .button {
			width: 166px;
			color: $secondColor;
		}
	}
}
</style>
